import { record } from 'fp-ts';
import { identity, pipe } from 'fp-ts/function';
import { EnterpriseProfilePrivileges } from '@mews-commander/data-access';

interface PrivilegesCountProps {
    privileges?: Partial<Record<keyof EnterpriseProfilePrivileges, boolean>> | null;
}

export const PrivilegesCount = ({ privileges }: PrivilegesCountProps) => (
    <>{privileges ? pipe(privileges, record.filter(identity), record.size) : 0}</>
);
